declare global {
  interface Window {
    TalkdeskChatSDK?: (
      node: string,
      props: Record<string, unknown>,
    ) => {
      init: (config: Record<string, unknown>) => void
    }

    __talkdeskInitialized?: boolean
    __talkdeskInstance?: any
  }
}

export function useTalkdeskChat() {
  const appSettingsStore = useAppSettingsStore()
  let initPromise: Promise<void> | null = null

  const initialize = (): Promise<void> => {
    if (initPromise)
      return initPromise

    initPromise = (async () => {
      const settings = appSettingsStore?.talkdeskSettings

      if (!settings)
        return

      const enabled = settings.enableChat === true

      if (!enabled)
        return

      const flowId = settings.chatFlowId
      const region = settings.chatRegion

      if (!flowId || !region)
        return

      if (import.meta.server)
        return

      // Prevent multiple initializations
      if (window.__talkdeskInitialized)
        return

      await useTalkdeskLoader()

      const CONTAINER_ID = 'tdWebchat'

      // Create container if needed
      if (!document.getElementById(CONTAINER_ID)) {
        const container = document.createElement('div')
        container.id = CONTAINER_ID
        document.body.appendChild(container)
      }

      if (!window.TalkdeskChatSDK)
        return

      const webchat = window.TalkdeskChatSDK(
        CONTAINER_ID,
        {
          flowId,
          accountId: '',
          region,
        },
      )

      webchat.init({
        enableEmoji: true,
        enableUserInput: true,

        styles: {
          chatThemeMainFont: 'Roboto-Regular',

          chatThemeColor: '#0D3644',
          chatHoverThemeColor: '#30435e',

          chatIcon:
            'https://prd-cdn-talkdesk.talkdesk.com/cdn-assets/latest/talkdesk/product/app-icons/sms.svg',

          chatTitleIcon:
            'https://prd-cdn-talkdesk.talkdesk.com/cdn-assets/latest/talkdesk/product/app-icons/sms.svg',

          chatTitle: settings.chatTitle ?? '',
          chatSubtitle: settings.chatSubtitle ?? '',

          startChatButtonBackgroundColor: '#1c4f66',

          welcomeMessageBackgroundColor: '#31729D',

          customMessageNoBubbleColor: '#1c4f66',

          customButtonBorderColor: '#cc4a10',

          customButtonColor: '#FFFFFF',

          customButtonBackgroundColor: '#cc4a10',

          customDropdownLabel: 'I am...',

          welcomeMessageTitleFontSize: '12px',

          welcomeMessageTitleColor: '#FFFFFF',

          welcomeMessageContentFontFamily: 'Roboto-Regular',

          welcomeMessageContentFontSize: '12px',

          welcomeMessageContentColor: '#FFFFFF',
        },
      })

      window.__talkdeskInstance = webchat
      window.__talkdeskInitialized = true
    })().finally(() => {
      // IMPORTANT: allow retry if init failed or early-returned
      initPromise = null
    })

    return initPromise
  }

  const openChat = async () => {
    await initialize()

    if (window.__talkdeskInstance?.open) {
      window.__talkdeskInstance.open()
    }
  }

  return {
    initialize,
    openChat,
  }
}
